import React from "react";
import styled from "@emotion/styled";
import PublicIcon from "@mui/icons-material/Public";
import BorderLessInput from "../Custom/BorderLessInput";
import { useFormContext } from "react-hook-form";

const PhoneInputRoot = styled.div`
  align-items: center;
  display: flex;
  height: 50px;
  margin-top: 10px;
  width: 100%;
`;

const PhoneInputFlagContainer = styled.div`
  align-items: center;
  display: flex;
  border: 1px solid white;
  border-right: none;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  height: 50px;
  justify-content: center;
  width: 65px;
`;

const PhoneInputContainer = styled.div`
  align-items: center;
  border: 1px solid white;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  display: flex;
  height: 50px;
  width: calc(100% - 65px);
`;

const PlaceholderAligner = styled.div`
  margin-left: 10px;
`;

export default function CustomPhoneInput() {
  const { watch, setValue } = useFormContext();

  return (
    <React.Fragment>
      {watch("options")?.map((field: any, index: number) => {
        return (
          <React.Fragment>
            <BorderLessInput
              color="white"
              placeHolder="Label (Optional)"
              value={watch(`options[${index}].label`) || ""}
              setValue={(value: string) => {
                setValue(`options[${index}].label`, value);
              }}
            />
            <PhoneInputRoot>
              <PhoneInputFlagContainer>
                <PublicIcon />
              </PhoneInputFlagContainer>
              <PhoneInputContainer>
                <PlaceholderAligner>
                  <BorderLessInput
                    color="white"
                    placeHolder="+1"
                    value={"+1"}
                  />
                </PlaceholderAligner>
              </PhoneInputContainer>
            </PhoneInputRoot>
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
}
